var site = site || {}; site.doMobileRedirect = true;
